import type pdfMake from 'pdfmake/build/pdfmake';
let pdfMakeInstance: typeof pdfMake | null = null;

export const loadPdfMake = async () => {
  if (pdfMakeInstance) return pdfMakeInstance;
  const [{ default: pdfMake }, { default: fonts }] = await Promise.all([
    import('pdfmake/build/pdfmake'),
    import('utils/pdfmakeVfsFonts'),
  ]);
  pdfMake.vfs = fonts;
  pdfMakeInstance = pdfMake;
  return pdfMakeInstance;
};
